export default "__VITE_ASSET__ddd56480__"